import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "main innerContainer" }
const _hoisted_2 = { class: "data-cont" }

import { ref, onMounted, computed, watch } from "vue";
import type { Ref, ComputedRef } from "vue";
import { isInViewport } from "@/composables/mobileWatcher";
import { get } from "lodash";
import { useMenuStore } from "@/store/pinia/menu";
import { handleResize } from "@/composables/resizeHandler";
import ReasonItem from "../../UI/ReasonItem.vue";

// Define store

export default /*#__PURE__*/_defineComponent({
  props: {
    contentData: {
        type: Object,
    },
},
  setup(__props) {

const props = __props

/**
 * @author Tornike Jortmenadze (Jortsoft)
 */

const store = useMenuStore();

// Define props


// Define variables
const locoScrollY: ComputedRef<number> = computed(() => store.locoScrollY);
const mobileClass: Ref<Boolean> = ref(false);
const activeElem: Ref<Boolean> = ref(false);
const { windowWidth } = handleResize();

// Reactive data
const getData: ComputedRef<object> = computed(() => {
    return get(props.contentData, "data.list");
});

// Custom functions
const mobileScroll = (): void => {
    document.getElementById("app").addEventListener("scroll", () => {
        if (
            document.querySelector(".reasons .labelMask") === null ||
            document.querySelector(".reasons .labelMask") === undefined
        ) {
            return;
        }
        if (isInViewport(document.querySelector(".reasons .labelMask"))) {
            mobileClass.value = true;
        }
    });
};
const enablePointer = (): void => {
    activeElem.value = true;
};

// Watcher
watch(locoScrollY, () => {
    if (isInViewport(document.querySelector(".reasons .labelMask"))) {
        window.setTimeout(enablePointer, 2000);
    }
});

// Function expression
onMounted(() => {
    if (window.innerWidth < 1024) {
        mobileScroll();
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["reasons", { 'is-inview': mobileClass.value }]),
    "data-scroll": ""
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getData), (item, index) => {
          return (_openBlock(), _createBlock(ReasonItem, {
            key: index,
            item: item,
            index: index,
            activeElem: activeElem.value
          }, null, 8, ["item", "index", "activeElem"]))
        }), 128))
      ])
    ])
  ], 2))
}
}

})